
import React from 'react';
import NewSideBarHousing from '../layout/newSideBar/NewSideBar';



const ResponsiveNavigation = ({ uiTexts, className = "" }) => {


  return (
    <div className={className}>
    
        <NewSideBarHousing uiTexts={uiTexts} />
      
    </div>
  );
};

export default ResponsiveNavigation;
